const icon = '<svg class="pn-icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#000" fill-rule="evenodd" d="M12.707 15.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414z" clip-rule="evenodd"/></svg>';
export const angle_small_down = icon;
export const angleSmallDown = icon;
